module.exports = __webpack_public_path__ + "static/media/YF29_0.54cb8c3d.jpg";